/* tslint:disable */
var TrackingEventClientFunnel = /** @class */ (function () {
    function TrackingEventClientFunnel(args) {
        this.EVENT_ID = 142;
        this.data = args;
        this.data.eventId = this.EVENT_ID;
    }
    return TrackingEventClientFunnel;
}());
export { TrackingEventClientFunnel };
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/TrackingEventClientFunnel.ts
// module id = 1694
// module chunks = 3